/**
 * PHP 라우트( current_controller() / current_action() )의 short class name 과 동기화한 TS 엔트리맵.
 * ( 예: web.php App\Controllers\Site\Marketing\HomeController@index → "HomeController", "index" )
 */
import {
    HomeController,
    ReservationController,
    IntroController,
    BrandStoryController,
    FranchiseController,
    MenuController,
    StoresController,
    EventsController,
    NoticeController,
    PressController,
    DetailController,
    ContactController,
    JoinController,
    LegalController,
    PeopleController,
    AdvisoryBoardController,
    AboutController,
    ActivitiesController,
    AuthController,
    AwardsController,
    CalendarController,
    CollaborationsController,
    CollectController,
    CoreProjectController,
    EducationController,
    EducationProgramController,
    EmailVerificationController,
    EquipmentBookingController,
    EquipmentController,
    EquipmentEducationController,
    EquipmentNoticeController,
    EquipmentScheduleController,
    EquipmentStaffNoteController,
    FacilitiesController,
    FrameworkController,
    GuideController,
    LearningController,
    LearningResourceController,
    LocaleSwitchController,
    NewsController,
    OaSdlController,
    OutreachController,
    PartneringController,
    PlatformController,
    PostPasswordController,
    PostThreadController,
    PortfolioController,
    PublicationController,
    ResearchController,
    ResourcesController,
    SearchController,
    SitemapController,
    TechnicalGroupController,
    UsageController,
} from "../home/controllers";

import {
    AdminAnalyticsController,
    AdminAuthController,
    AdminBoardController,
    AdminController,
    AdminDocsLibraryController,
    AdminFeatureController,
    AdminMenuController,
    AdminPreferencesController,
    AdminProjectDocController,
    RoleController,
    UserController,
    AdminContactController,
    AdminNameMarketItemController,
    AdminSiteinfoController,
    AdminSiteLocaleController,
    AdminSiteMetaController,
    AdminWorkController,
    AdminWorkCategoryController,
    AdminWorkServiceController,
    AdminWorkTemplateController,
    AdminSortableIndexController,
    AdminAccessControlController,
    AdminActivityLogController,
    AdminSystemLogsController,
    AdminAnalyticsExcludedIpController,
    AdminAttachmentController,
    AdminBoardCategoryController,
    AdminBoardFieldController,
    AdminBoardFieldOptionController,
    AdminBoardTagController,
    AdminContentBlockController,
    AdminEquipmentCategoryController,
    AdminEquipmentController,
    AdminEquipmentStaffNoteController,
    AdminFeeGuideController,
    AdminJoinApplicationController,
    AdminMailSettingsController,
    AdminMenuCategoryController,
    AdminMenuInfoController,
    AdminMenuSetController,
    AdminMenuSetsPageController,
    AdminMenuTagController,
    AdminNotificationConfigController,
    AdminNotificationController,
    AdminOpsController,
    AdminPopupController,
    AdminPostController,
    AdminPostThreadController,
    AdminProjectSyncController,
    AdminPublicationController,
    AdminReservationApplicationController,
    AdminReservationSlotController,
    AdminResourceHintsAuditController,
    AdminStoreController,
    AdminSystemController,
    AdminThemeAuditController,
    AdminUiAuditController,
    AdminUiEnvController,
    AdminWorkSectionController,
    AdminAdFraudController,
    AdminCmsMenuController,
} from "../admin/controllers";

export type ControllerMap = Record<string, () => void>;

export const controllerRegistry: Record<string, ControllerMap> = {
    // ── admin ────────────────────────────────────────────────────────────
    AdminAnalyticsController,
    AdminAdFraudController,
    AdminAnalyticsExcludedIpController,
    AdminAuthController,
    AdminBoardController,
    AdminBoardCategoryController,
    AdminBoardFieldController,
    AdminBoardFieldOptionController,
    AdminBoardTagController,
    AdminCmsMenuController,
    AdminContentBlockController,
    AdminController,
    AdminContactController,
    AdminDocsLibraryController,
    AdminFeatureController,
    AdminJoinApplicationController,
    AdminMailSettingsController,
    AdminMenuController,
    AdminMenuCategoryController,
    AdminMenuInfoController,
    AdminMenuSetController,
    AdminMenuSetsPageController,
    AdminMenuTagController,
    AdminNameMarketItemController,
    AdminNotificationConfigController,
    AdminNotificationController,
    AdminOpsController,
    AdminPopupController,
    AdminPostController,
    AdminPostThreadController,
    AdminPreferencesController,
    AdminProjectDocController,
    AdminProjectSyncController,
    AdminSiteinfoController,
    AdminSiteLocaleController,
    AdminSiteMetaController,
    AdminStoreController,
    AdminSystemController,
    AdminThemeAuditController,
    AdminUiAuditController,
    AdminUiEnvController,
    AdminWorkController,
    AdminWorkCategoryController,
    AdminWorkSectionController,
    AdminWorkServiceController,
    AdminWorkTemplateController,
    AdminActivityLogController,
    AdminSystemLogsController,
    AdminAttachmentController,
    AdminEquipmentCategoryController,
    AdminEquipmentController,
    AdminEquipmentStaffNoteController,
    AdminFeeGuideController,
    AdminResourceHintsAuditController,
    AdminReservationApplicationController,
    AdminReservationSlotController,
    AdminAccessControlController,
    RoleController,
    UserController,
    // 정렬 전용 단순 인덱스(연구·장비) — 한 shim 을 여러 PHP 컨트롤러 이름에 매핑.
    AdminCoreProjectController: AdminSortableIndexController,
    AdminTechnicalGroupController: AdminSortableIndexController,
    AdminAwardController: AdminSortableIndexController,
    AdminEquipmentNoticeController: AdminSortableIndexController,
    AdminEquipmentEducationController: AdminSortableIndexController,
    AdminFacilitiesEquipmentController: AdminSortableIndexController,
    AdminFacilitiesCategoriesController: AdminSortableIndexController,
    AdminFacilitiesFeeGuidesController: AdminSortableIndexController,
    AdminPersonController: AdminSortableIndexController,
    // ── site public ──────────────────────────────────────────────────────
    HomeController,
    ReservationController,
    IntroController,
    BrandStoryController,
    FranchiseController,
    MenuController,
    StoresController,
    EventsController,
    NoticeController,
    PressController,
    DetailController,
    ContactController,
    JoinController,
    LegalController,
    PeopleController,
    AdvisoryBoardController,
    AboutController,
    ActivitiesController,
    AuthController,
    AwardsController,
    CalendarController,
    CollaborationsController,
    CollectController,
    CoreProjectController,
    EducationController,
    EducationProgramController,
    EmailVerificationController,
    EquipmentBookingController,
    EquipmentController,
    EquipmentEducationController,
    EquipmentNoticeController,
    EquipmentScheduleController,
    EquipmentStaffNoteController,
    FacilitiesController,
    FrameworkController,
    GuideController,
    LearningController,
    LearningResourceController,
    LocaleSwitchController,
    NewsController,
    OaSdlController,
    OutreachController,
    PartneringController,
    PlatformController,
    PostPasswordController,
    PostThreadController,
    PortfolioController,
    PublicationController,
    ResearchController,
    ResourcesController,
    SearchController,
    SitemapController,
    TechnicalGroupController,
    UsageController,
};
